export default {
  name: 'equipment',
  path: 'equipment',
  component: () => import('@/views/container/Redirect.vue'),
  meta: {
    title: '设施设备管理',
    redirect: true,
    hideSubMenu: true,
    icon: 'icon-a-jianqu17'
  },
  children: [
    {
      name: 'equipment-list',
      path: 'equipment-list',
      component: () => import('@/views/container/Redirect.vue'),
      meta: { title: '设备台账列表', menuChildren: true, redirect: true },
      children: [
        {
          name: 'equipment-list-index',
          path: '',
          component: () => import('@/views/equipment/equipment-list/EquipmentList.vue'),
          meta: { title: '设备台账列表' }
        }, 
        {
          name: 'equipment-detail',
          path: 'equipment-detail',
          component: () => import('@/views/equipment/equipment-list/EquipmentDetail.vue'),
          meta: {title: '设备详情', redirect: false},
        },
        {
          name: 'equipment-form',
          path: 'equipment-form',
          component: () => import('@/views/equipment/equipment-list/EquipmentForm.vue'),
          meta: {title: '新增', redirect: false},
        },
      ]
    },
    {
      name: 'goods-manage',
      path: 'goods-manage',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {title: '备品备件管理', redirect: true, icon: 'icon-usergroup'},
      children: [
        {
          name: 'goods-library',
          path: 'goods-library',
          component: () => import('@/views/equipment/goods-manage/goods-library/GoodsLibrary.vue'),
          meta: {title: '备品备件库', redirect: false},
        },
       
        {
          name: 'in-library',
          path: 'in-library',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {title: '入库管理', redirect: true},
          children: [
            {
              name: 'in-library-index',
              path: '',
              component: () => import('@/views/equipment/goods-manage/in-library/InLibrary.vue'),
              meta: {title: '入库管理'},
            },
            {
              name: 'in-form',
              path: 'in-form',
              component: () => import('@/views/equipment/goods-manage/in-library/InForm.vue'),
              meta: {title: '入库'},
            },
            {
              name: 'in-detail',
              path: 'in-detail',
              component: () => import('@/views/equipment/goods-manage/in-library/InDetail.vue'),
              meta: {title: '入库管理详情'}
            },
          ]
        },
        {
          name: 'out-library',
          path: 'out-library',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {title: '出库管理', redirect: true},
          children: [
            {
              name: 'out-library-index',
              path: '',
              component: () => import('@/views/equipment/goods-manage/out-library/OutLibrary.vue'),
              meta: {title: '出库管理'},
            },
            {
              name: 'out-form',
              path: 'out-form',
              component: () => import('@/views/equipment/goods-manage/out-library/OutForm.vue'),
              meta: {title: '入库'},
            },
            {
              name: 'out-detail',
              path: 'out-detail',
              component: () => import('@/views/equipment/goods-manage/out-library/OutDetail.vue'),
              meta: {title: '出库管理详情'}
            },
          ]
        },
     
      ]
    },
    {
      name: 'goods-maintenance',
      path: 'goods-maintenance',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {title: '维保管理', redirect: true, icon: 'icon-usergroup'},
      children: [
        {
          name: 'maintenance-stencil',
          path: 'maintenance-stencil',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {title: '维保模板', redirect: true},
          children: [
            {
              name: 'maintenance-stencil-index',
              path: '',
              component: () => import('@/views/equipment/goods-maintenance/maintenance-stencil/Stencil.vue'),
              meta: {title: '维保模板'},
            },
            {
              name: 'stencil-form',
              path: 'stencil-form',
              component: () => import('@/views/equipment/goods-maintenance/maintenance-stencil/StencilForm.vue'),
              meta: {title: '新增模板'},
            },
            {
              name: 'stencil-detail',
              path: 'stencil-detail',
              component: () => import('@/views/equipment/goods-maintenance/maintenance-stencil/StencilDetail.vue'),
              meta: {title: '模板详情'}
            },
          ]
        },
        {
          name: 'maintenance-plan',
          path: 'maintenance-plan',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {title: '维保计划', redirect: true},
          children: [
            {
              name: 'maintenance-plan-index',
              path: '',
              component: () => import('@/views/equipment/goods-maintenance/maintenance-plan/Plan.vue'),
              meta: {title: '维保计划'},
            },
            {
              name: 'maintenance-plan-form',
              path: 'maintenance-plan-form',
              component: () => import('@/views/equipment/goods-maintenance/maintenance-plan/PlanForm.vue'),
              meta: {title: '新增计划'},
            },
            {
              name: 'maintenance-plan-detail',
              path: 'maintenance-plan-detail',
              component: () => import('@/views/equipment/goods-maintenance/maintenance-plan/PlanDetail.vue'),
              meta: {title: '设备计划详情'}
            },
            {
              name: 'maintenance-plan-infos',
              path: 'maintenance-plan-infos',
              component: () => import('@/views/equipment/goods-maintenance/maintenance-plan/PlanInfos.vue'),
              meta: {title: '计划详情'}
            },
          ]
        },
        {
          name: 'maintenance-task',
          path: 'maintenance-task',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {title: '维保任务', redirect: true},
          children: [
            {
              name: 'maintenance-task-index',
              path: '',
              component: () => import('@/views/equipment/goods-maintenance/maintenance-task/Task.vue'),
              meta: {title: '维保任务'},
            },
            {
              name: 'fill-data',
              path: 'fill-data',
              component: () => import('@/views/equipment/goods-maintenance/maintenance-task/FillData.vue'),
              meta: {title: '补录数据'},
            },
            {
              name: 'maintenance-task-form',
              path: 'maintenance-task-form',
              component: () => import('@/views/equipment/goods-maintenance/maintenance-task/TaskForm.vue'),
              meta: {title: '新增临时任务'},
            },
            {
              name: 'maintenance-task-detail',
              path: 'maintenance-task-detail',
              component: () => import('@/views/equipment/goods-maintenance/maintenance-task/TaskDetail.vue'),
              meta: {title: '计划任务详情'}
            },
          ]
        },
        {
          name: 'maintenance-record',
          path: 'maintenance-record',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {title: '维保记录', redirect: true},
          children: [
            {
              name: 'maintenance-record-index',
              path: '',
              component: () => import('@/views/equipment/goods-maintenance/maintenance-record/Record.vue'),
              meta: {title: '维保记录'},
            },
            {
              name: 'maintenance-record-detail',
              path: 'maintenance-record-detail',
              component: () => import('@/views/equipment/goods-maintenance/maintenance-record/RecordDetail.vue'),
              meta: {title: '维保记录详情'}
            },
          ]
        },
      ]
    },
    {
      name: 'equip-params-set',
      path: 'equip-params-set',
      component: () => import('@/views/equipment/params-set/ParamsSet.vue'),
      meta: {title: '参数设置'},
    },
  ]
};
